export const showPrivacySettings = () => {
  window.UC_UI?.showSecondLayer();
};
